module.exports = __webpack_public_path__ + "static/img/home_v10.9b17a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/home_v10.svg
// module id = N8be
// module chunks = 0